import React from "react";
import UseContext from "hooks/useContext";

const SKELETON_ROWS = [1, 2, 3];

const PerimeterListSkeleton = () => {
    const { language } = UseContext();

    return (
        <div role="status" aria-busy="true">
            <span className="sr-only">
                {language.getValue("perimeters.list.loading")}
            </span>
            {SKELETON_ROWS.map((row) => (
                <div
                    key={row}
                    aria-hidden="true"
                    className="flex animate-pulse items-center justify-between gap-4 border-b border-gray-100 py-3"
                >
                    <div className="h-4 w-40 rounded bg-gray-200" />
                    <div className="h-10 w-48 rounded-md bg-gray-200" />
                </div>
            ))}
        </div>
    );
};

export default PerimeterListSkeleton;
